import { render, staticRenderFns } from "./CompareKpiItem.vue?vue&type=template&id=25306bbe&scoped=true&"
import script from "./CompareKpiItem.vue?vue&type=script&lang=js&"
export * from "./CompareKpiItem.vue?vue&type=script&lang=js&"
import style0 from "./CompareKpiItem.vue?vue&type=style&index=0&id=25306bbe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25306bbe",
  null
  
)

export default component.exports